module.exports = __webpack_public_path__ + "static/media/groomingHeroImage.9fa68d0d.png";